import { render, staticRenderFns } from "./updatephone.vue?vue&type=template&id=6490a7cb&scoped=true"
import script from "./updatephone.vue?vue&type=script&lang=js"
export * from "./updatephone.vue?vue&type=script&lang=js"
import style0 from "./updatephone.vue?vue&type=style&index=0&id=6490a7cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6490a7cb",
  null
  
)

export default component.exports